<script lang="typescript">
  // packages
  import { intcomma, pluralize } from 'journalize';

  // types
  import type { Readable } from 'svelte/store';
  import type { NationalInterface, PresidentRaceFeed } from '../interfaces';

  export let store: Readable<NationalInterface>;

  const bidenHead = window.HEADSHOTS.biden;
  const trumpHead = window.HEADSHOTS.trump;

  $: electorsTotal = $store.president.electors_total;
  $: electorsRemaining = $store.president.electors_remaining;
  $: electorsToWin = $store.president.electors_to_win;
  $: biden = $store.president.biden;
  $: trump = $store.president.trump;

  $: bidenWidth = (biden.electors_won / electorsTotal) * 100;
  $: trumpWidth = (trump.electors_won / electorsTotal) * 100;
  $: remainingWidth = (electorsRemaining / electorsTotal) * 100;
</script>

<div class="w-full position-relative text-sans-serif space-y-n2">
  <dl class="display-flex justify-between leading-none text-medium">
    <div class="text-left color-dem-dark">
      <dd class="text-5xl">{biden.electors_won}</dd>
    </div>
    <div class="text-right color-gop-dark">
      <dd class="text-5xl">{trump.electors_won}</dd>
    </div>
  </dl>
  <div class="position-relative">
    <div class="display-flex w-full bar-height">
      <div class="bg-dem" style="width: {bidenWidth}%" />
      {#if remainingWidth > 0}
        <div class="bg-neutral" style="width: {remainingWidth}%" />
      {/if}
      <div class="bg-gop" style="width: {trumpWidth}%" />
    </div>
    <div
      class="display-flex justify-center w-full h-full position-absolute top-0">
      <div class="balance-bar" />
    </div>
  </div>

  <div class="display-flex justify-between text-sm color-dark-grey">
    <div class="text-left bop-side color-dem-dark">
      <div class="duo-head biden-head">
        <img src={bidenHead} alt="Joe Biden" />
      </div>
      <dt class="balance-name text-2xl">
        {biden.family_name}{#if biden.is_winner}✓{/if}
        <p class="vote-totals text-sm color-dark-grey">
          {intcomma(biden.votes)}
          vote{pluralize(biden.votes)}
        </p>
      </dt>
    </div>
    <p class="text-center">{electorsToWin} to win</p>
    <div class="text-right bop-side color-gop-dark">
      <dt class="balance-name text-2xl">
        {#if trump.is_winner}✓{/if}{trump.family_name}
        <p class="vote-totals text-sm color-dark-grey">
          {intcomma(trump.votes)}
          vote{pluralize(trump.votes)}
        </p>
      </dt>
      <div class="duo-head trump-head">
        <img src={trumpHead} alt="Donald Trump" />
      </div>
    </div>
  </div>
</div>
